export const formatCollectionDate = (isoDate: string) => {
  const date = new Date(isoDate);

  const day = new Date(date).toLocaleString("en-GB", {
    day: "2-digit",
  });
  const month = new Date(date).toLocaleString("en-GB", {
    month: "2-digit",
  });
  const year = new Date(date).toLocaleString("en-GB", {
    year: "numeric",
  });

  return `${day}/${month}/${year}`;
};
